import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation updateBankAccountDuplicationStateMutation(
    $input: UpdateBankAccountDuplicationStateInput!
    $byAuth0Id: String!
    $afterDate: Date!
    $beforeDate: Date!
    $bankAccountIdEq: String!
    $stateEq: String
    $storeIdEq: String
    $integrationItemIdEq: Int
    $nameCont: String
    $byMerchantNames: String
    $nameNotIContAll: String
  ) {
    updateBankAccountDuplicationState(input: $input) {
      bankAccount {
        ...BankAccountCell_bankAccount
      }
      fastCash(byAuth0Id: $byAuth0Id) {
        ...FastCashContainer_fastCash
      }
      errors {
        key
        messages
      }
    }
  }
`;

const UpdateBankAccountDuplicationState = (environment, params, args = {}) => {
  const {
    id,
    duplicationState,
    afterDate,
    beforeDate,
    byAuth0Id,
    bankAccountIdEq,
    originalBankAccountId,
    stateEq,
  } = params;

  const variables = {
    input: {
      id,
      duplicationState,
      originalBankAccountId,
    },
    byAuth0Id,
    afterDate,
    beforeDate,
    bankAccountIdEq,
    stateEq,
  };

  return commit(environment, {
    mutation,
    variables,
    ...args,
  });
};

export default UpdateBankAccountDuplicationState;
